// Países aceites no registo normal (validação rigorosa no servidor: formato + dígito de controlo)
export const TAX_COUNTRIES = ['CV', 'PT', 'BR', 'CH', 'FR', 'ES'];

export const TAX_HINTS = {
  CV: 'NIF de Cabo Verde: 9 dígitos.',
  PT: 'NIF de Portugal: 9 dígitos com dígito de controlo.',
  BR: 'CNPJ do Brasil: 14 caracteres, numérico ou alfanumérico (ex.: 11.222.333/0001-81 ou 12.ABC.345/01DE-35).',
  CH: 'UID da Suíça: CHE-123.456.788.',
  FR: 'SIREN de França: 9 dígitos.',
  ES: 'NIF/CIF de Espanha (ex.: B12345674, 12345678Z ou X1234567L).',
};
